import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";

import { ordersAction as orders } from "../../../../redux/reducers/Orders"; // TODO replace in chat, all addresses with direct ones from src/redux/reducers/Orders

const useExecutorsActions = (): useExecutorsActions.Props => {
	const dispatch = useDispatch();

	const onSaveColumnsIdsTable = useCallback(
		(value: string[]) => {
			dispatch(orders.executors.tableSettings.setColumnIds(value));
		},
		[dispatch],
	);

	const setExecutorsSort = useCallback(
		({ column, type }) => {
			dispatch(
				orders.executors.filter.setExecutorsSort({ column, type }),
			);
		},
		[dispatch],
	);

	return useMemo(
		() => ({
			onSaveColumnsIdsTable,
			setExecutorsSort,
		}),
		[onSaveColumnsIdsTable, setExecutorsSort],
	);
};

declare namespace useExecutorsActions {
	interface Props {
		onSaveColumnsIdsTable: (value: string[]) => void;
		setExecutorsSort: (data: { column: string; type: string }) => void;
	}
}

export default useExecutorsActions;
